import { Controller } from '@hotwired/stimulus'

/**
 * Stimulus controller to expose click method that will click the element.
 */
export default class ClickController extends Controller {
  static values =
    {
      autoClick: { type: Boolean, default: true }
    }

  connect() {
    super.connect()
    if (this.autoClickValue) {
      this.click()
    }
  }

  click() {
    this.element.click();
  }
}